import { throttle } from "throttle-debounce";
/**
 * Flexible Font Sizing based on container
 */
export namespace FlexFont {
	/**
	 * Function intializes all Accordion Modules
	 * @constructor
	 */
	let runFlexFont = (elements) => {
		elements.forEach((element:HTMLElement) => {
			let relFontsize = element.offsetWidth*0.05 <= 18 ? element.offsetWidth*0.05 : 18;
			element.style.fontSize = relFontsize+'px';
		});
	}

	export const init = () => {
		let elements:NodeList = document.querySelectorAll(".js-flex-font");
		if(!elements) {
			return;
		}
		runFlexFont(elements);

		window.addEventListener('resize', throttle(100, false, () => {
			runFlexFont(elements);
		}));
	}
}
